export const AXIOS_DEFAULT_OPTIONS = { credentials: 'include' };

export default {};



// WEBPACK FOOTER //
// ./src/actions/index.js